import client from "../client";
import { getScanConfig } from "./getScanConfig";

const getScan = (data?: any) => {
  return client({ ...getScanConfig(data.qrCodeId) });
};

export default {
  getScan,
};
